import React, { useMemo } from 'react';

import { LinkButton } from 'common/components/Button/LinkButton';
import { Flex } from 'common/components/Flex';
import { LinkRegularLR1 } from 'common/components/Typography';
import { useLocalization } from 'common/providers/LocaleProvider';
import type { DispatchState } from 'common/types/React';
import { extractLineNoList, isAllSelected } from '../../utils/products';
import type { ProductDetails } from '../types';

interface SelectAllProps {
  products: ProductDetails[];
  selectedProducts: string[];
  setSelectedProducts: DispatchState<string[]>;
}

const SelectAll = ({ products, selectedProducts, setSelectedProducts }: SelectAllProps) => {
  const { t } = useLocalization();
  const lineNoList = useMemo(() => extractLineNoList(products), [products]);
  const hasAllSelected = useMemo(
    () => isAllSelected(lineNoList, selectedProducts),
    [lineNoList, selectedProducts]
  );
  const label = hasAllSelected ? t('h24_deselect_all_products') : t('h24_select_all_products');

  const onClick = () => {
    setSelectedProducts(!hasAllSelected ? lineNoList : []);
  };

  return (
    <Flex mx="sp_16" mb="sp_16">
      <LinkButton onClick={onClick}>
        <LinkRegularLR1 as="span" color="sys.neutral.border.strong">
          {label}
        </LinkRegularLR1>
      </LinkButton>
    </Flex>
  );
};

export default SelectAll;
